/**
 * Delete the item with the given key from LocalStorage.
 *
 * @param key - The key of the current item in LocalStorage.
 */
export const deleteCached = (key: string): void => {
	return window.localStorage.removeItem(key);
};
